"use client";

import { forwardRef } from "react";
import { Phone, Mail, Send, MessageCircle } from "lucide-react";
import {
  PageFooterSection,
  type TeamMember as PFTeamMember,
  type ContactLink,
} from "@/components/blocks/PageFooterSection";
import type { TeamMember } from "@/entities/team";
import type { ContactChannel } from "@/entities/contacts";
import type { FaqItem } from "@/entities/faq";

const ICON_BY_KIND: Record<ContactChannel["kind"], React.ReactNode> = {
  phone: <Phone className="w-5 h-5" />,
  email: <Mail className="w-5 h-5" />,
  telegram: <Send className="w-5 h-5" />,
  whatsapp: <MessageCircle className="w-5 h-5" />,
  address: <Mail className="w-5 h-5" />,
};

interface FAQSectionProps {
  faqs: FaqItem[];
  teamMembers: TeamMember[];
  contactChannels: ContactChannel[];
  accentColor?: string;
}

/* ─────────────────────────────────────────────────────────────
   Тонкая обёртка — Help-страница
───────────────────────────────────────────────────────────── */
export const FAQSection = forwardRef<HTMLElement, FAQSectionProps>(
  function FAQSection(
    { faqs, teamMembers, contactChannels, accentColor = "var(--help)" },
    ref,
  ) {
    const teamMembersUI: PFTeamMember[] = teamMembers.map((m) => ({
      name: m.name,
      role: m.role,
      initials: m.initials,
      photo: m.photo,
    }));
    const contactLinks: ContactLink[] = contactChannels.map((c) => ({
      icon: ICON_BY_KIND[c.kind],
      title: c.title,
      value: c.value,
      href: c.href,
    }));
    return (
      <PageFooterSection
        ref={ref}
        blockId="faq"
        faqs={faqs}
        teamMembers={teamMembersUI}
        teamLabel="Команда Practicum Help"
        contactLinks={contactLinks}
        accentColor={accentColor}
      />
    );
  },
);

FAQSection.displayName = "FAQSection";
